import * as z from "zod";

export const updateTripleWhaleOmsSettings = {
  name: "updateTripleWhaleOmsSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    storeUrl: z.string().nullable().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
